/* @flow weak */

import QuestionStore from '../stores/QuestionStore.jsx';
import PartStore from '../stores/PartStore.jsx';

export default function buildAnswerConflictMarkup(conflictingAnswers, skuAnswers) {
  let output = `
    <table cellSpacing="0">
      <thead>
        <tr>
          <th>Question</th>
          <th>Saved Part</th>
          <th>Locked SKU Part</th>
        </tr>
      </thead>
  `;

  _.each(conflictingAnswers, conflict => {
    const conflictingSkuAnswer = _.filter(skuAnswers, skuAnswer => skuAnswer.question_id === conflict.question_id)[0];
    const question = QuestionStore.getQuestionById(conflict.question_id);
    const savedPart = PartStore.getPartByQuestionAndPartId(conflict.question_id, conflict.part_id);
    const skuPart = PartStore.getPartByQuestionAndPartId(conflict.question_id, conflictingSkuAnswer.part_id);

    output += `
      <tbody>
        <tr>
          <td>${question != null ? question.name : 'No longer in configuration'} (ID: ${conflict.question_id})</td>
          <td>${savedPart != null ? savedPart.name : 'No longer in configuration'} (ID: ${conflict.part_id})</td>
          <td>${skuPart != null ? skuPart.name : 'No longer in configuration'} (ID: ${conflictingSkuAnswer.part_id})</td>
        </tr>
      </tbody>
    `;
  });

  output += '</table>';

  return output;
}


// WEBPACK FOOTER //
// ./src/base/scripts/helpers/BuildAnswerConflictMarkup.js